import React, { useState, useEffect } from 'react';
import { firestore, doc, setDoc, updateDoc, getDocs, collection, query, where, addDoc } from '../config/firebaseConfig'; // Certifique-se de que essas importações estão corretas
import InputMask from 'react-input-mask';
import './ContatoForm.css';

function ContatoForm({ aluno, onCancel, onUpdate, tenantId }) {
  const [formData, setFormData] = useState({
    nome: '',
    dataNascimento: '',
    genero: '',
    email: '',
    telefone: '',
    curso: '',
    turma: '',
    interesses: '',
    linkedin: ''
  });
  const [step, setStep] = useState(0);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [cursos, setCursos] = useState([]);
  const [turmas, setTurmas] = useState([]);

  useEffect(() => {
    if (aluno) {
      setFormData(aluno);
    }
  }, [aluno]);

  useEffect(() => {
    const fetchCursosTurmas = async () => {
      const cursosSnapshot = await getDocs(collection(firestore, 'historicoAluno'));
      const cursosList = [];
      const turmasList = [];

      cursosSnapshot.forEach(doc => {
        const data = doc.data();
        if (data.curso && !cursosList.includes(data.curso)) {
          cursosList.push(data.curso);
        }
        if (data.turma && !turmasList.includes(data.turma)) {
          turmasList.push(data.turma);
        }
      });

      setCursos(cursosList);
      setTurmas(turmasList);
    };

    fetchCursosTurmas();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({ ...prevData, [name]: value }));
    setError('');
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validateTelefone = (telefone) => {
    const telefoneSemMascara = telefone.replace(/\D/g, ''); // Remove tudo que não for número
    return telefoneSemMascara.length === 11; // Verifica se tem 11 dígitos (padrão Brasil com DDD)
  };

  const handleNext = () => {
    const currentStep = steps[step];
    const currentValue = formData[currentStep.inputProps.name];

    if (currentStep.inputProps.required && !currentValue) {
      setError(`Por favor, preencha o campo "${currentStep.label}".`);
      return;
    }

    // Valida e-mail
    if (currentStep.inputProps.name === 'email' && !validateEmail(currentValue)) {
      setError('Por favor, insira um e-mail válido.');
      return;
    }

    // Valida telefone
    if (currentStep.inputProps.name === 'telefone' && !validateTelefone(currentValue)) {
      setError('Por favor, insira um telefone válido com 11 dígitos.');
      return;
    }

    if (step < steps.length - 1) {
      setStep(step + 1);
    } else {
      handleSubmit(); // Chama handleSubmit quando chegar ao último passo
    }
  };

  const handlePrevious = () => {
    if (step > 0) {
      setStep(step - 1);
    }
  };

  const handleSubmit = async () => {
    const email = formData.email; 
    const telefone = formData.telefone; 

    const { exists, field } = await checkIfAlunoExists(email, telefone);

    if (exists) {
      console.log(`Aluno já existe pelo campo: ${field}`);
      setError(`Já existe um aluno com este ${field}.`);
      return;
    }

    await cadastrarAluno();
    console.log("Aluno cadastrado com sucesso!");
  };

  const checkIfAlunoExists = async (email, telefone) => {
    const telefoneSemMascara = telefone.replace(/\D/g, '');
    const telefoneComCodigo = `55${telefoneSemMascara}`;

    console.log(`Verificando se o aluno existe com email: ${email} e telefone: ${telefoneComCodigo}`);

    const emailQuery = query(
      collection(firestore, 'contatos'),
      where('email', '==', email)
    );
    const emailSnapshot = await getDocs(emailQuery);

    const telefoneQuery = query(
      collection(firestore, 'contatos'),
      where('telefone', '==', telefoneComCodigo)
    );
    const telefoneSnapshot = await getDocs(telefoneQuery);

    if (!emailSnapshot.empty) {
      return { exists: true, field: 'email' };
    }

    if (!telefoneSnapshot.empty) {
      return { exists: true, field: 'telefone' };
    }

    return { exists: false };
  };

  const cadastrarAluno = async () => {
    const timestamp = new Date().toISOString();
    const tipoContato = formData.curso ? 'Aluno' : 'Lead';
    const telefoneSemMascara = formData.telefone.replace(/\D/g, '');
    const telefoneComCodigo = `55${telefoneSemMascara}`;

    const updatedData = {
      ...formData,
      tipoContato,
      telefone: telefoneComCodigo,
      tenantId, // Adiciona o tenantId no registro
      dataUltimaAtualizacao: timestamp,
      origem: 'Manual',
      status: 'Pendente',
    };

    try {
      if (aluno?.id) {
        await updateDoc(doc(firestore, 'contatos', aluno.id), updatedData);
      } else {
        // Deixa o Firestore gerar o documentId automaticamente
        await addDoc(collection(firestore, 'contatos'), {
          ...updatedData,
          dataCriacao: timestamp
        });
      }
      setFormData({
        nome: '',
        dataNascimento: '',
        genero: '',
        email: '',
        telefone: '',
        curso: '',
        turma: '',
        interesses: '',
        linkedin: ''
      });
      setSuccess('Ótimo trabalho! Seus dados foram salvos com sucesso.');
      setTimeout(() => {
        if (onUpdate) onUpdate(updatedData);
        onCancel();
      }, 3000);
    } catch (error) {
      console.error('Erro ao salvar aluno:', error);
      setError('Houve um problema ao salvar os dados. Por favor, tente novamente mais tarde.');
    }
  };

  const steps = [
    { label: 'Nome', inputProps: { name: 'nome', type: 'text', value: formData.nome, required: true } },
    { label: 'Data de Nascimento', inputProps: { name: 'dataNascimento', type: 'date', value: formData.dataNascimento, required: true } },
    { label: 'E-mail', inputProps: { name: 'email', type: 'email', value: formData.email, required: true } },
    { label: 'Telefone', inputProps: { name: 'telefone', type: 'text', value: formData.telefone, required: true } },
    { label: 'Curso', inputProps: { name: 'curso', type: 'text', value: formData.curso } },
    { label: 'Turma', inputProps: { name: 'turma', type: 'text', value: formData.turma } },
    { label: 'LinkedIn', inputProps: { name: 'linkedin', type: 'url', value: formData.linkedin } },
  ];

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleNext();
    }
  };

  const currentStep = steps[step];
  const progressPercentage = ((step + 1) / steps.length) * 100;
  const isContinueEnabled = !currentStep.inputProps.required || (formData[currentStep.inputProps.name] && formData[currentStep.inputProps.name].trim() !== '');

  const getInstructionMessage = () => {
    if (step === 0) return "Vamos começar! Por favor, preencha o nome completo.";
    if (step === 1) return "Agora, informe a data de nascimento.";
    if (step === 2) return "Digite o e-mail para contato.";
    if (step === 3) return "Informe o número de telefone.";
    if (step === 4) return "Informe o curso, se aplicável.";
    if (step === 5) return "Informe a turma em que você está.";
    if (step === 6) return "Adicione o link do seu perfil no LinkedIn, se tiver.";
    return "";
  };

  return (
    <div className="aluno-form-container">
      <div className="instruction-message">
        {getInstructionMessage()}
      </div>
      <div className="progress-bar">
        <div className="progress" style={{ width: `${progressPercentage}%` }}></div>
      </div>
      <form className="aluno-form" onSubmit={(e) => e.preventDefault()}>
        <div className="form-group">
          <label htmlFor={currentStep.inputProps.name}>{currentStep.label}</label>
          {currentStep.inputProps.name === 'telefone' ? (
            <InputMask
              id={currentStep.inputProps.name}
              name={currentStep.inputProps.name}
              mask="(99) 99999-9999"
              value={currentStep.inputProps.value}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
              required={currentStep.inputProps.required}
            />
          ) : currentStep.inputProps.name === 'curso' ? (
            <select
              id="curso"
              name="curso"
              className="curso-select"
              value={currentStep.inputProps.value}
              onChange={handleChange}
              required={currentStep.inputProps.required}
            >
              <option value="">Selecione um curso</option>
              {cursos.map((curso, index) => (
                <option key={index} value={curso.nome}>{curso}</option>
              ))}
            </select>
          ) : currentStep.inputProps.name === 'turma' ? (
            <select
              id="turma"
              name="turma"
              className="turma-select"
              value={currentStep.inputProps.value}
              onChange={handleChange}
              required={currentStep.inputProps.required}
            >
              <option value="">Selecione uma turma</option>
              {turmas.map((turma, index) => (
                <option key={index} value={turma.nome}>{turma}</option>
              ))}
            </select>
          ) : (
            <input
              id={currentStep.inputProps.name}
              name={currentStep.inputProps.name}
              type={currentStep.inputProps.type}
              value={currentStep.inputProps.value}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
              required={currentStep.inputProps.required}
            />
          )}
        </div>
        {error && <div className="form-feedback form-error">{error}</div>}
        {success && <div className="form-feedback form-success">{success}</div>}
        <div className="form-actions">
          <button type="button" onClick={handlePrevious} disabled={step === 0}>Voltar</button>
          <button type="button" onClick={onCancel}>Cancelar</button>
          {!currentStep.inputProps.required && step < steps.length - 1 && (
            <button type="button" onClick={handleNext}>Pular</button>
          )}
          <button type="button" onClick={handleNext} disabled={!isContinueEnabled}>
            {step === steps.length - 1 ? 'Salvar' : 'Continuar'}
          </button>
        </div>
      </form>
    </div>
  );
}

export default ContatoForm;
